import { optimizedAppearDataAttribute as p } from "./atoms-v2965.js";
function e(t) {
  return t.props[p];
}
export {
  e as getOptimisedAppearId
};
